import { FC, useMemo } from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';
import { News } from '../../lib/models/news';
import { isEmpty } from '../../lib/util/typeGuards';

import LatestNewsContent from './components/LatestNewsContent/LatestNewsContent';
import NewsCard from './components/NewsCard/NewsCard';
import SkeletonNewsCard from './components/SkeletonNewsCard/SkeletonNewsCard';
import { LatestNewsProps } from './LatestNews.types';

import styles from './LatestNews.module.scss';

const SKELETON_ITEMS = 4;
const SKELETON_KEYS = Array.from({ length: SKELETON_ITEMS }, (_, index) => `news-skeleton-${index}`);

const LatestNews: FC<LatestNewsProps> = ({
  newsItems,
  isLoggedIn,
  isLoading,
  selectedSymbol,
  smallTitle,
  isExtended,
  onCardClick,
}: LatestNewsProps): JSX.Element => {
  const isNewsAvailable = !isEmpty(newsItems);

  const computedNewsCards = useMemo(() => {
    if (newsItems?.length > 0) {
      return newsItems.map((item: News) => (
        <NewsCard isExtended={isExtended} key={item.id} item={item} onCardClick={onCardClick} />
      ));
    }

    return SKELETON_KEYS.map(key => <SkeletonNewsCard isExtended={isExtended} key={key} />);
  }, [newsItems, isExtended, onCardClick]);

  return (
    <>
      {!isExtended && (
        <h6 className={classNames(GlobalClassesEnum.CommonDiscoverTitle, styles.wrapperTitle)}>
          {smallTitle ? lang.symbolDetailsTabNews() : lang.commonDiscoverNews()}
        </h6>
      )}
      <LatestNewsContent
        newsCards={computedNewsCards}
        isLoggedIn={isLoggedIn}
        selectedSymbol={selectedSymbol}
        isNewsAvailable={isNewsAvailable}
        isLoading={isLoading}
      />
    </>
  );
};

export default LatestNews;
